<script>

    import { createEventDispatcher } from 'svelte'
    import { toast } from 'bulma-toast'

    import StripeService from '../$services/stripe.service'

    import InputText from '../$components/input.text.svelte'
    import Form from '../$components/form.svelte'

    const dispatch = createEventDispatcher()

    const STRIPE_KEY = _CONST_.STRIPE_KEY

    let loading = false
    let data = {}

    async function createCheckout() {

        loading = true
        const resp = await StripeService.createCheckout(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        window.Stripe(STRIPE_KEY).redirectToCheckout({ sessionId: resp.data.sessionId })
        dispatch('created', resp.data)
    }

</script>

<div class="columns">
    <div class="column">
        <Form on:submit={createCheckout} on:canceled {loading} >
            <InputText bind:value={data.amount} label="Monto" icon="dollar-sign" placeholder="MXN"/>
        </Form>
    </div>
</div>